// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"89f45119","350":"644d0f05","393":"644d0f05","679":"b054e2d7","722":"e746e803","815":"a75f19d9"}[chunkId] + ".chunk.css";
};